import { PositionMetrics } from 'components/PositionList/PositionTable'
import PositionListItem from 'components/PositionListItem'
import React from 'react'
import { PositionDetails } from 'types/position'

type PositionListProps = React.PropsWithChildren<{
  positions: PositionDetails[]
  searchQuery?: string
  visible?: boolean
  rangeFilter?: 'all' | 'in-range' | 'out-of-range'
  createdAtByTokenId?: Record<string, number>
  rowOrder?: Record<string, number>
  onPositionMetricsChange?: (positionKey: string, metrics?: PositionMetrics) => void
}>

export default function PositionList({
  positions,
  searchQuery,
  visible = true,
  rangeFilter = 'all',
  createdAtByTokenId,
  rowOrder,
  onPositionMetricsChange,
}: PositionListProps) {
  return (
    <>
      {positions.map((position) => {
        const tokenId = position.tokenId.toString()
        const positionKey = `v3:${tokenId}`
        return (
          <PositionListItem
            key={positionKey}
            {...position}
            searchQuery={searchQuery}
            createdAt={createdAtByTokenId?.[tokenId]}
            order={rowOrder?.[positionKey]}
            visible={visible}
            rangeFilter={rangeFilter}
            onPositionMetricsChange={onPositionMetricsChange}
          />
        )
      })}
    </>
  )
}
